export default [
    {
        title: 'Purchasing & Sending',
        questions: [
            {
                question: 'Are there any fees associated with the purchase of a gift card?',
                answer:
                    'No. You will only be charged the face value of the gift card. e-Gift cards are sent via email and incur no shipping charges.',
            },
            {
                question: "Can I change the value of a gift card after I've paid for it?",
                answer: 'Not at this time. You can purchase additional e-gift cards as needed.',
            },
            {
                question: 'How do I cancel the purchase of a gift card?',
                answer:
                    'Since the delivery date is today or in the past, your purchase cannot be cancelled.',
            },
            {
                question: 'What payment methods do you accept?',
                answer: 'VISA, MasterCard, American Express, Discover.',
            },
            {
                question: 'When is my credit card charged for my purchase?',
                answer: 'Your credit card is charged at the time of purchase.',
            },
            {
                question: 'Can I buy an e-Gift card for myself?',
                answer:
                    'Yes. You can do so by entering your email as the recipient email address when ordering an e-Gift card.',
            },
            {
                question:
                    'I want a printed e-Gift Card to present to someone as a gift. How do I do this?',
                answer:
                    'You will receive an e-Gift card alert via email. Follow the instructions in this message to retrieve your e-Gift card and then print. The resulting printout may be presented as a gift to the recipient.',
            },
            {
                question: 'How can I get a refund?',
                answer: 'All sales are final and no refund can be issued.',
            },
        ],
    },
    {
        title: 'Receiving & Redeeming',
        questions: [
            {
                question: 'How do I check my balance?',
                answer: 'There is a link to the balance of the card in the email.',
            },
            {
                question: 'What exactly does the recipient receive when I send an e-Gift card?',
                answer:
                    "A message is sent to the recipient informing them of your gift, with a link to retrieve it online. The link in the email opens a page showing the e-Gift card you created (the design you selected, with your recipient's name and your personalized message), its value and code number. This page also gives simple instructions for redeeming the e-Gift card.",
            },
            {
                question: 'When is the e-Gift card sent to the recipient?',
                answer:
                    'The e-Gift Card alert message is sent immediately. Scheduling will be available in the near future.',
            },
            {
                question: 'Where can I use my Gift card?',
                answer:
                    'Gift cards can be redeemed at the merchant location at which the e-Gift card was purchased. They can be redeemed through online ordering with the merchant or at the physical location.',
            },
            {
                question: 'When does the Gift card expire?',
                answer: 'There is no expiration date on your e-Gift card.',
            },
            {
                question: "Can I reload my Gift card after I've spent the full value?",
                answer:
                    'Not at this time. However, you can purchase additional gift cards as needed.',
            },
        ],
    },
    {
        title: 'Receiving & Redeeming',
        questions: [
            {
                question:
                    'How do I know the recipient actually received the e-Gift card I sent them?',
                answer:
                    'Notices  will be sent out 3, 5 , 10, 20, 30 days after the e-Gift card is sent if the recipient has not yet opened the e-Gift Card email.',
            },
            {
                question: 'What if you cannot locate your e-Gift card?',
                answer: 'If you lost your gift card, contact customer support immediately.',
            },
            {
                question:
                    'If there are any other concerns or issues not answered by this FAQ please contact support for further assistance.',
                answer:
                    'You can email restaurantpos@spoton.com support or call 877-814-4102 to speak to a support agent.',
            },
        ],
    },
];
